import React from 'react';
import { useSelector } from 'react-redux';
import cN from 'classnames';
import { LightBox } from '@lion-design/core';
import { TravelTypes } from '@Redux/detail/Group/interfaces';
import { RootState } from '@Redux/detail/store';
import Titles from './subComponents/Titles';
import DetailList from './subComponents/DetailList';
import PriceList from './subComponents/PriceList';
import TaxList from './subComponents/TaxList';
import styles from './styles.module.scss';

interface I_Props {
    open: boolean;
    ToggleLightBox: (open: boolean) => void;
    storyData?: I_StoryData;
}

export interface I_StoryData {
    isB2E: boolean;
    TravelType: TravelTypes;
}

function GroupDetailPrice({ open, ToggleLightBox }: I_Props) {
    const PricesInfo = useSelector((state: RootState) => state.groupReducer.PricesInfo);

    return PricesInfo ? (
        <LightBox
            className={cN(styles.container, 'group_detail_price')}
            open={open}
            ToggleLightBox={ToggleLightBox}
        >
            <Titles />
            <DetailList />
            <PriceList />
            <TaxList />
        </LightBox>
    ) : null;
}

export default GroupDetailPrice;
